import * as angular from 'angular';

class CheckboxesGroupList {

}

angular.module('naut').component('checkboxesGroupList', {
    template: require('./checkboxes-group-list.component.html'),
    controller: CheckboxesGroupList,
    controllerAs: 'ctrl',
    bindings: {
        items: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/extras/shared/checkboxes-group-list/checkboxes-group-list.component.ts